import { render, staticRenderFns } from "./ConnectKraken.vue?vue&type=template&id=6aff89f2&"
import script from "./ConnectKraken.vue?vue&type=script&lang=js&"
export * from "./ConnectKraken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports